import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { MessageService } from 'primeng/api';
import { map, mergeMap } from 'rxjs/operators';
import { HttpBaseService } from 'src/app/base/http-base.service';
import { AppGlobalService } from 'src/app/services/app.global.service';
import {
  currentDeleteScreen,
  deleteScreens,
  generatePages,
  getAppNavigation,
  getChildTables,
  getFieldsInfoForTable,
  getIdMapping,
  getScreens,
  getScreenStructure,
  saveScreens,
  setAppNavigation,
  setChildTables,
  setErrorMessage,
  setFieldsInfoForTable,
  setIdMapping,
  setNewlyAddedScreen,
  setScreenStructure,
  setSelectedScreens,
  updateCurrentScreen,
  updateFieldsInfoForTable,
  updateScreens,
  updateScreenStructure,
  setLandngScreen,
  updateLandScr,
  saveconfAndFileCntFailure,
  saveconfAndFileCntSuccess,
  updateScnAndDMCOnfig,
  getTableOrder,
  setTableOrder,
  getPagesForQuery,
  getTablesForQuery,
  setPagesForQuery,
  setTablesForQuery,
  setQueryTableData,
  getQueryTableData,
  getStandardListPages,
  setStandardListPages,
  getTableData,
  setTableData,
  getMsScreenData,
  getPageVariables,
  deletePageVariable,
  savePageVariable,
  setPageVariables,
  deletePageVariableSuccess,
  savePageVariableSuccess,
  setMsScreenData
} from '../actions/screens.actions';
import { UtilService } from 'src/app/services/util.service';
import { allScreens } from '../selectors/screens.selector';
import { ApiConstants } from '@api-constants';

@Injectable()
export class ScreensEffects {
  private actions$ = inject(Actions);
  private baseService = inject(HttpBaseService);
  private store = inject(Store);
  private utilService = inject(UtilService);
  private appGlobalService = inject(AppGlobalService);
  private messageService = inject(MessageService);
  private translate = inject(TranslateService);

  selectedScreens: any[];
  screenId: any;
  public static genStatusTimeout: any;

  getAppNavStructure$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(getAppNavigation),
        map((action: any) => {
          return this.baseService[action.appNavApiConstants?.method](action.appNavApiConstants).subscribe(
            (appNavData: any) => {
              this.store.dispatch(setAppNavigation({ appNavStructure: appNavData }));
            }
          );
        })
      ),
    {
      dispatch: false
    }
  );

  getScreenStructure$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(getScreenStructure),
        map((action: any) => {
          return this.baseService[action.getScreenStructureApiConstants?.method](
            action.getScreenStructureApiConstants,
            action.sid
          ).subscribe((screenData: any) => {
            this.store.dispatch(setScreenStructure({ selectedScreenStructure: screenData || null }));
          });
        })
      ),
    {
      dispatch: false
    }
  );

  setSelectedScreens$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(setSelectedScreens),
        map((action: any) => {
          const scrSub = this.store.select(allScreens).subscribe((allscrs) => {
            if (scrSub) {
              scrSub.unsubscribe();
            }
            this.selectedScreens = [...allscrs];
          });
        })
      ),
    {
      dispatch: false
    }
  );

  updateScreensData$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(updateScreens),
        map((action: any) => {
          return this.baseService[action.screensApiConstants?.method](
            action.screensApiConstants,
            action.screensData
          ).subscribe((screensData: any) => {
            // include all the screens that have added
            this.selectedScreens = [...this.selectedScreens, ...screensData];
            this.store.dispatch(setSelectedScreens({ selectedScreens: this.selectedScreens }));
            this.refreshMemberScreenData();
          });
        })
      ),
    {
      dispatch: false
    }
  );

  updateCurrentScreens$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(updateCurrentScreen),
        map((action: any) => {
          return this.baseService[action.updateScreenApi?.method](
            action.updateScreenApi,
            action.screenData
          ).subscribe();
        })
      ),
    {
      dispatch: false
    }
  );

  updateScreensStructure = createEffect(
    () =>
      this.actions$.pipe(
        ofType(updateScreenStructure),
        map((action: any) => {
          if (!action.updateStructureApiConstants) {
            return;
          }
          this.store.dispatch(saveconfAndFileCntSuccess({ results: null }));
          this.store.dispatch(saveconfAndFileCntFailure({ error: null }));
          return this.baseService[action.updateStructureApiConstants?.method](
            action.updateStructureApiConstants,
            action.updatedStructure
          ).subscribe(
            (screenData: any) => {
              if (action.updateStructureApiConstants.url === 'datamodelconfigured') {
                this.store.dispatch(saveconfAndFileCntSuccess({ results: screenData }));
              }
              const scr = this.selectedScreens.find((sc) => sc.sid === screenData.sid);
              if (scr) {
                const updScrs = this.selectedScreens.map((sc) => {
                  return sc.sid === scr.sid ? screenData : sc;
                });
                this.selectedScreens = [...updScrs];
              }
              this.store.dispatch(setSelectedScreens({ selectedScreens: this.selectedScreens }));
              this.refreshMemberScreenData();
            },
            (err: any) => {
              this.store.dispatch(saveconfAndFileCntFailure({ error: err }));
            }
          );
        })
      ),
    {
      dispatch: false
    }
  );

  getAllScreensData$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(getScreens),
        map((action: any) => {
          return this.baseService[action.getScreensApiConstants?.method](action.getScreensApiConstants).subscribe(
            (screensData: any) => {
              this.selectedScreens = screensData;
              this.store.dispatch(setSelectedScreens({ selectedScreens: screensData }));
            }
          );
        })
      ),
    {
      dispatch: false
    }
  );

  getAllIdMapping$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(getIdMapping),
        map((action: any) => {
          return this.baseService[action.getIdMappingApiConstants?.method](action.getIdMappingApiConstants).subscribe(
            (idMappingData: any) => {
              this.store.dispatch(setIdMapping({ idMaps: idMappingData }));
            }
          );
        })
      ),
    {
      dispatch: false
    }
  );

  saveScreen$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(saveScreens),
        map((action: any) => {
          return this.baseService[action.saveScreensApiConstants?.method](
            action.saveScreensApiConstants,
            action.screensData
          ).subscribe((screensData: any) => {
            this.store.dispatch(setNewlyAddedScreen({ addedScreen: screensData }));
            this.selectedScreens = [...this.selectedScreens, screensData];
            this.store.dispatch(setSelectedScreens({ selectedScreens: this.selectedScreens }));
            this.refreshMemberScreenData();
          });
        })
      ),
    {
      dispatch: false
    }
  );

  genPages$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(generatePages),
        map((action: any) => {
          this.utilService.setGitError(false);
          return this.baseService[action.genPagesApi?.method](action.genPagesApi, action.genParams).subscribe(
            (genPages: any) => {
              // Page generation triggered
            },
            (error) => {
              this.utilService.setGitError(true);
              console.log(error);
              const errObj = error.error;
              if (errObj && errObj.MESSAGE) {
                this.showMessage('error', this.translate.instant(errObj.MESSAGE));
              } else if (errObj && errObj.ERROR_CODE) {
                this.showMessage('error', this.translate.instant(errObj.ERROR_CODE));
              } else {
                this.showMessage('error', 'Update Prototype failed');
              }
              this.store.dispatch(setErrorMessage({ errorData: error }));
            }
          );
        })
      ),
    {
      dispatch: false
    }
  );

  getFieldsInfoForTable$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(getFieldsInfoForTable),
        map((action: any) => {
          return this.baseService[action.getFIApiConstants?.method](action.getFIApiConstants).subscribe(
            (fieldsInfo: any) => {
              this.store.dispatch(setFieldsInfoForTable({ fieldsInfo }));
            }
          );
        })
      ),
    {
      dispatch: false
    }
  );

  updateFieldsInfoForTable$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(updateFieldsInfoForTable),
        map((action: any) => {
          return this.baseService[action.updateFIApiConstants?.method](
            action.updateFIApiConstants,
            action.fiData
          ).subscribe((fieldsInfo: any) => {
            //this.store.dispatch(setFieldsInfoForTable({fieldsInfo}))
          });
        })
      ),
    {
      dispatch: false
    }
  );

  getChildTablesByParentTableId$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(getChildTables),
        map((action: any) => {
          return this.baseService[action.getChildTableApi?.method](action.getChildTableApi, {
            tableId: action.tableId
          }).subscribe((childTables: any) => {
            this.store.dispatch(setChildTables({ childTables }));
          });
        })
      ),
    {
      dispatch: false
    }
  );

  deleteSelectedScreen$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(deleteScreens),
        map((action: any) => {
          return this.baseService[action.deleteScreenApi?.method](action.deleteScreenApi, action.screensId).subscribe(
            (screensData: any) => {
              this.store.dispatch(currentDeleteScreen({ deletedScreenId: action.screensId }));
              const ind = this.selectedScreens.findIndex((sc) => sc.sid === action.screensId?.id);
              if (ind > -1) {
                const allScs = [...this.selectedScreens];
                allScs.splice(ind, 1);
                this.selectedScreens = [...allScs];
                this.store.dispatch(setSelectedScreens({ selectedScreens: this.selectedScreens }));
              }
            }
          );
        })
      ),
    {
      dispatch: false
    }
  );

  setLandngScreen$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(setLandngScreen),
        map((action: any) => {
          if (!action.apiConstants?.url) {
            return;
          }
          this.screenId = action.apiConstants.url.split('/')[3];
          return this.baseService[action.apiConstants?.method](action.apiConstants).subscribe((data) => {
            if (this.screenId) {
              this.store.dispatch(updateLandScr({ landScrId: this.screenId }));
            }
          });
        })
      ),
    {
      dispatch: false
    }
  );

  updateScnAndDMCOnfig = createEffect(
    () =>
      this.actions$.pipe(
        ofType(updateScnAndDMCOnfig),
        map((action: any) => {
          if (!action.updateApiCons) {
            return;
          }
          this.store.dispatch(saveconfAndFileCntSuccess({ results: null }));
          this.store.dispatch(saveconfAndFileCntFailure({ error: null }));
          return this.baseService[action.updateApiCons?.method](action.updateApiCons, action.updatedData).subscribe(
            (screenData: any) => {
              this.store.dispatch(saveconfAndFileCntSuccess({ results: screenData }));
            },
            (err: any) => {
              this.store.dispatch(saveconfAndFileCntFailure({ error: err }));
            }
          );
        })
      ),
    {
      dispatch: false
    }
  );

  getTableOrder$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(getTableOrder),
        map((action: any) => {
          return this.baseService[action.tableOrderApiConstants?.method](action.tableOrderApiConstants).subscribe(
            (res: any) => {
              this.store.dispatch(setTableOrder({ tableOrder: res }));
            }
          );
        })
      ),
    {
      dispatch: false
    }
  );

  getPagesForQuery$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(getPagesForQuery),
        map((action: any) => {
          return this.baseService[action.queryPagesApiConstants?.method](action.queryPagesApiConstants).subscribe(
            (res: any) => {
              this.store.dispatch(setPagesForQuery({ queryPages: res }));
            }
          );
        })
      ),
    {
      dispatch: false
    }
  );

  getTablesForQuery$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(getTablesForQuery),
        map((action: any) => {
          return this.baseService[action.queryTblsApiConstants?.method](action.queryTblsApiConstants).subscribe(
            (res: any) => {
              this.store.dispatch(setTablesForQuery({ queryTables: res }));
            }
          );
        })
      ),
    {
      dispatch: false
    }
  );

  getQueryTableData$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(getQueryTableData),
        map((action: any) => {
          return this.baseService[action.queryTblDataApiConstants?.method](
            action.queryTblDataApiConstants,
            action.sid
          ).subscribe((res: any) => {
            this.store.dispatch(setQueryTableData({ queryTableData: res }));
          });
        })
      ),
    {
      dispatch: false
    }
  );

  getTableData$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(getTableData),
        map((action: any) => {
          return this.baseService[action.tblDataApiConstants?.method](action.tblDataApiConstants, action.sid).subscribe(
            (res: any) => {
              this.store.dispatch(setTableData({ tableData: res }));
            }
          );
        })
      ),
    {
      dispatch: false
    }
  );

   getMsScreenData$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(getMsScreenData),
        map((action: any) => {
          return this.baseService[action.msScrDataApiConstants?.method](action.msScrDataApiConstants, action.suiteId).subscribe(
            (res: any) => {
              this.store.dispatch(setMsScreenData({ msScreenData: res }));
            }
          );
        })
      ),
    {
      dispatch: false
    }
  );

  private refreshMemberScreenData(): void {
    const applicationType = (this.appGlobalService.get('applicationType') || '').toString().toUpperCase();
    if (applicationType !== 'SUITE' && applicationType !== 'MEMBER') {
      return;
    }

    const suiteId = this.appGlobalService.get('suiteId');
    if (!suiteId) {
      return;
    }

    this.store.dispatch(
      getMsScreenData({ msScrDataApiConstants: ApiConstants.getScreensForMemAndSuiteApp, suiteId: { suiteId } })
    );
  }

  getStandardListPages$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(getStandardListPages),
        map((action: any) => {
          return this.baseService[action.stdPagesApiConstants?.method](action.stdPagesApiConstants).subscribe(
            (res: any) => {
              this.store.dispatch(setStandardListPages({ standardPages: res }));
            }
          );
        })
      ),
    {
      dispatch: false
    }
  );

  getPageVariables$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(getPageVariables),
        map((action: any) => {
          return this.baseService[action.getPageVariablesApiConst?.method](
            action.getPageVariablesApiConst,
            action.data
          ).subscribe((res: any) => {
            this.store.dispatch(setPageVariables({ setPageVariablesData: res }));
          });
        })
      ),
    { dispatch: false }
  );

  deletePageVariable$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(deletePageVariable),
        map((action: any) => {
          return this.baseService[action.deletePageVariableApiConst?.method](
            action.deletePageVariableApiConst,
            action.data
          ).subscribe((res: any) => {
            this.store.dispatch(deletePageVariableSuccess({ deletePageVariableSuccessData: action.data }));
          });
        })
      ),
    { dispatch: false }
  );

  savePageVariable$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(savePageVariable),
        map((action: any) => {
          return this.baseService[action.savePageVariableApiConst?.method](
            action.savePageVariableApiConst,
            action.data
          ).subscribe(
            (res: any) => {
              this.store.dispatch(savePageVariableSuccess({ savePageVariableSuccessData: res }));
            },
            (err: any) => {
              this.store.dispatch(savePageVariableSuccess({ savePageVariableSuccessData: '' }));
              if (err?.error?.MESSAGE === 'ALREADY_EXISTS') {
                this.showMessage(
                  'error',
                  this.translate.instant('DUPLICATE_PAGE_VARIABLE').replace('{field}', action.data.name)
                );
              } else if (err?.error?.MESSAGE === 'FIELD_PRESENT_IN_TABLE') {
                this.showMessage(
                  'error',
                  this.translate
                    .instant('PAGE_VARIABLE_NAME_ALREADY_PRESENT_IN_TABLE')
                    .replace('{field}', action.data.name)
                );
              } else if (err?.error?.MESSAGE) {
                this.showMessage(
                  'error',
                  err?.error?.MESSAGE
                    ? this.translate.instant(err?.error?.MESSAGE)
                    : this.translate.instant('PAGE_VARIABLE_SAVE_FAILED')
                );
              }
            }
          );
        })
      ),
    { dispatch: false }
  );

  showMessage(status: string, message: string, detail?: string) {
    this.messageService.clear();
    this.messageService.add({
      life: 10000,
      severity: status,
      summary: message,
      detail: detail
    });
  }
}
